import { PureComponent } from 'react';
import classNames from 'classnames';
import { NullStateCard } from '@hc/component-lib/hclib/components/molecules/null-state-card';
import SVGInline from 'react-svg-inline';

import {
  AVM_KEY_HC,
  AVM_KEY_USER,
  AVM_KEY_USER_ENTERED,
  AVM_KEY_RENTAL_USER_ENTERED,
  AVM_KEY_COMPS,
  AVM_KEY_RENTAL_COMPS,
  AVM_KEY_COMPS_AVG,
  AVM_KEY_RENTAL_COMPS_AVG,
  LABEL_FOR_AVM_KEY,
  VALUE_TYPE_RENTAL,
  NULL_STATE_WARNINGS
} from 'legacy/appstore/constants';

import { monthlyValueFormatter } from 'legacy/utils/formatters';

import PropertyExplorerAvmChart from 'legacy/components/PropertyExplorerAvmChart';
import Popover from 'legacy/components/generic/Popover';
import AvmSelectorItem from 'legacy/components/PropertyExplorerAvmSelectorItem';
import AvmSelectorUserEntered from 'legacy/components/AvmSelectorUserEntered';
import Chevron from 'legacy/components/generic/ChevronIcon';

import eyeIcon from 'legacy/assets/svg-inline/eye_icon.svg';

import OfferNowButtonContainer from '../containers/offer-now-button.container';

import {
  PropertyExplorerValue as theme,
  Common as commonTheme
} from 'legacy/css-modules';

export default class PropertyExplorerValue extends PureComponent {
  state = {
    isSelectingAvm: false
  };

  onSelect(avm) {
    this.setState({ isSelectingAvm: false });
    this.props.handleSelect(avm);
  }

  render() {
    const {
      selectedAvm,
      selectedAvmKey,
      avmsForSelector,
      avmHc,
      avmSelectorUserEntered,
      isReportEditable,
      isReadOnly,
      handleChangeUserEnteredValue,
      showAvmChart,
      className,
      classNameChart,
      isMonthlyValue,
      isAvmHcEmpty,
      dataHcNames,
      valueType,
      avmSelectorCompsValue,
      avmSelectorCompsAvg,
      trackOpenAvmSelector,
      offerNowAvailable
    } = this.props;
    let formattedAvmValue = monthlyValueFormatter(
      selectedAvm.value,
      isMonthlyValue
    );
    // If the adjusted AVM value is $0, display the HC AVM value instead, since
    // this means the adjustment (to property details) hasn't yet been made.
    if (selectedAvmKey === AVM_KEY_USER && !selectedAvm.value && avmHc) {
      formattedAvmValue =
        avmHc && monthlyValueFormatter(avmHc.value, isMonthlyValue);
    }

    const showNullRentalSelectorWarning =
      valueType === VALUE_TYPE_RENTAL && (!avmHc || !avmHc.value);
    const emptyCompAvmSelected =
      [AVM_KEY_COMPS, AVM_KEY_RENTAL_COMPS].indexOf(selectedAvmKey) > -1 &&
      (!selectedAvm || !selectedAvm.value);
    const emptyCompAvgSelected =
      [AVM_KEY_COMPS_AVG, AVM_KEY_RENTAL_COMPS_AVG].indexOf(selectedAvmKey) >
        -1 &&
      (!selectedAvm || !selectedAvm.value);
    return (
      <div
        className={classNames(theme['component'], className)}
        data-hc-name={dataHcNames.section}
      >
        <h2
          className={commonTheme['section-heading-small']}
          data-hc-name={dataHcNames.valueHeader}
        >
          {LABEL_FOR_AVM_KEY[selectedAvmKey]} :
          {isReportEditable && (
            <Popover
              popoverAlignment="left"
              isOpen={this.state.isSelectingAvm}
              classNameContent={theme.avmSelector}
              className={theme.avmSelectorContainer}
              onClick={trackOpenAvmSelector}
              Button={
                <a
                  data-hc-name={dataHcNames.adjustLink}
                  className={classNames(
                    theme['choose-avm-link'],
                    'hc-action-bold'
                  )}
                >
                  Choose value
                  <Chevron direction="down" />
                </a>
              }
            >
              <div className={theme['choose-avm-popover-accent']} />
              <div
                className={classNames(theme.chooseAvmItems, {
                  [theme.avmSelectorSingle]:
                    avmsForSelector &&
                    ((avmsForSelector.length === 1 && !isReportEditable) ||
                      (avmsForSelector.length === 0 &&
                        isReportEditable &&
                        !showNullRentalSelectorWarning))
                })}
                data-hc-name={dataHcNames.adjustPanel}
              >
                {avmsForSelector.map((selectorItem, i) => {
                  if (selectorItem.showNullState) {
                    return (
                      <div
                        key={`nullKey${i}`}
                        className={classNames(
                          theme['avm-selection-item'],
                          theme.avmSelectorItemNull
                        )}
                      >
                        <NullStateCard
                          title={
                            NULL_STATE_WARNINGS[selectorItem.nullStateInfoKey]
                              .title
                          }
                        >
                          {
                            NULL_STATE_WARNINGS[selectorItem.nullStateInfoKey]
                              .message
                          }
                        </NullStateCard>
                      </div>
                    );
                  } else {
                    return (
                      <AvmSelectorItem
                        dataHcNames={dataHcNames.avmSelectorItem}
                        key={`avm-selector-item-${selectorItem.avmKey}`}
                        {...selectorItem}
                        handleSelect={() => this.onSelect(selectorItem.avmKey)}
                      />
                    );
                  }
                })}
                {isReportEditable && (
                  <AvmSelectorUserEntered
                    {...avmSelectorUserEntered}
                    handleSelect={(value) => {
                      handleChangeUserEnteredValue(value);
                    }}
                  />
                )}
              </div>
            </Popover>
          )}
        </h2>
        {showAvmChart ? (
          <div className={theme.avmChartContainer}>
            <PropertyExplorerAvmChart
              dataHcNames={dataHcNames}
              className={classNameChart}
              selectedAvm={selectedAvm}
              selectedAvmKey={selectedAvmKey}
              formattedAvmValue={formattedAvmValue}
            />
          </div>
        ) : emptyCompAvmSelected ? (
          <div className={theme.avmSelectorInValueDisplay}>
            <AvmSelectorItem
              {...avmSelectorCompsValue}
              handleSelect={() => this.onSelect(avmSelectorCompsValue.avmKey)}
            />
          </div>
        ) : emptyCompAvgSelected ? (
          <div className={theme.avmSelectorInValueDisplay}>
            <AvmSelectorItem
              {...avmSelectorCompsAvg}
              handleSelect={() => this.onSelect(avmSelectorCompsAvg.avmKey)}
            />
          </div>
        ) : isAvmHcEmpty && selectedAvmKey === AVM_KEY_HC ? (
          <NullStateCard
            className={theme.avmHcNullState}
            title={NULL_STATE_WARNINGS.noAvmHc.title}
          >
            {NULL_STATE_WARNINGS.noAvmHc.message}
          </NullStateCard>
        ) : (
          <div className={theme['avm-value']} data-hc-name={dataHcNames.value}>
            {formattedAvmValue}
          </div>
        )}
        {(selectedAvmKey === AVM_KEY_USER_ENTERED ||
          selectedAvmKey === AVM_KEY_RENTAL_USER_ENTERED) && (
          <div className={theme.Disclaimer}>
            This value is not generated or endorsed by HouseCanary,
            <br />
            and it does not represent a broker price opinion (BPO)
            <br />
            or a formal appraisal.
          </div>
        )}
        {isReadOnly && (
          <div
            className={theme.ReadOnlyReportMsg}
            data-hc-name="read-only-message"
          >
            <SVGInline className={theme.ReadOnlyIcon} svg={eyeIcon} /> Read Only
            Report
          </div>
        )}
        {offerNowAvailable && <OfferNowButtonContainer />}
      </div>
    );
  }
}
